document.addEventListener(
  "DOMContentLoaded",
  () => {

    const cards =
      document.querySelectorAll(
        "#density-grid .option-card"
      );

    const hidden =
      document.getElementById(
        "stitchDensity"
      );

    cards.forEach(card => {

      card.addEventListener(
        "click",
        () => {

          cards.forEach(c =>
            c.classList.remove("active")
          );

          card.classList.add(
            "active"
          );

          hidden.value =
            card.dataset.density;

          console.log(
            "DENSITY:",
            hidden.value
          );

          document.dispatchEvent(
            new CustomEvent(
              "embroideryUpdated"
            )
          );

        }
      );

    });

  }
);